import { CountryCodes } from './countryCodes';

export interface Country {
    name: string;
    code: CountryCodes;
}

export const EmptyCountry = '';
